import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bae6402"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "email-connect p-d-flex p-flex-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-input" }, "EMAIL", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-input p-mt-4" }, "password", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_InputText, {
      class: "input-write",
      type: "text",
      modelValue: _ctx.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
    }, null, 8, ["modelValue"]),
    _hoisted_3,
    _createVNode(_component_Password, {
      class: "input-write",
      modelValue: _ctx.password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
      toggleMask: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_Button, {
      class: "red-button p-mt-5 w-100 btn",
      onClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.signIn ? 'Sign In' : 'Register'), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}